import React, { useEffect } from "react";
import "./ComingSoon.css";
import logo from "../assets/logo.svg";
import banner from "../assets/banner.gif";

const jackpots = [
  { name: "US Powerball", amount: "US$ 350 MILLION", growth: "1650% ↑ base" },
  { name: "EuroMillions", amount: "EUR€ 138 MILLION", growth: "711% ↑ base" },
  { name: "Mega Millions", amount: "US$ 120 MILLION", growth: "140% ↑ base" },
];

const ComingSoon = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  return (
    <div className="comingsoon">
      <img src={banner} alt="Lottery banner" className="banner" />

      <img src={logo} alt="WinLottosOnline logo" className="logo" />

      <main className="content">
        <h1>Play Global Lotteries Online</h1>
        <p style={{fontWeight: 600}}>Enter the World's Biggest Jackpots with Ease</p>
        <p className="tagline">Lowest Prices • Scanned Tickets • 100% Secure</p>

        <ul className="jackpots">
          {jackpots.map((j) => (
            <li key={j.name} className="jackpot-card">
              <h3>{j.name}</h3>
              <p className="amount">{j.amount}</p>
              <span className="growth">{j.growth}</span>
            </li>
          ))}
        </ul>
        <p className="countdown">We're launching soon. Stay tuned!</p>
      </main>

      <footer>© {new Date().getFullYear()} WinLottosOnline. All rights reserved.</footer>
    </div>
  );
};

export default ComingSoon;